const enableIfNotHeadlessChrome = () => {
  const userAgent = typeof window !== 'undefined' ? window.navigator?.userAgent : undefined;

  const E2E_USER_AGENT = 'HeadlessChrome';
  const UNIT_TEST_USER_AGENT = 'jsdom';

  return !userAgent?.includes(E2E_USER_AGENT) && !userAgent?.includes(UNIT_TEST_USER_AGENT);
};

export const isPendoEnabledForTeachAndAdmin = enableIfNotHeadlessChrome;
